import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { AuthText } from './components/auth-layout';
import FormattedMessage from '../../components/formatted-message';

export const SIGN_UP_AUTH_LINK = 'SIGN_UP_AUTH_LINK';
export const LOGIN_AUTH_LINK = 'LOGIN_AUTH_LINK';
export const RESET_PASSWORD_AUTH_LINK = 'RESET_PASSWORD_AUTH_LINK';
export const LICENSE_AUTH_LINK = 'LICENSE_AUTH_LINK';

export const SIGN_UP_IS_AVAILABLE = false;

export const AuthOptionLinks = ({ linksToShow }) => {
    if (!linksToShow || (Array.isArray(linksToShow) && linksToShow.length === 0)) {
        return <div />;
    }

    return (
        <Fragment>
            {linksToShow.map(linkEl => {
                if (linkEl === LOGIN_AUTH_LINK) {
                    return (
                        <AuthText key={linkEl}>
                            <FormattedMessage id="signUp.haveAnAccount" />{' '}
                            <a href={'/login'}>
                                <FormattedMessage id="signUp.loginHere" />
                            </a>
                        </AuthText>
                    );
                }

                if (linkEl === SIGN_UP_AUTH_LINK) {
                    return (
                        <AuthText key={linkEl}>
                            {!!SIGN_UP_IS_AVAILABLE && (
                                <a href={'/sign-up'}>
                                    <FormattedMessage id="signUp.title" />
                                </a>
                            )}
                        </AuthText>
                    );
                }

                if (linkEl === RESET_PASSWORD_AUTH_LINK) {
                    return (
                        <AuthText key={linkEl}>
                            <a href={'/forgot-password'}>
                                <FormattedMessage id="forgotPassword.link" />
                            </a>
                        </AuthText>
                    );
                }

                if (linkEl === LICENSE_AUTH_LINK) {
                    return (
                        <AuthText key={linkEl}>
                            <FormattedMessage id="signUp.BySingingUpYouAgreeToOur" />{' '}
                            <a href={'/license'} target="_blank" rel="noopener noreferrer">
                                <FormattedMessage id="signUp.termsAndConditions" />
                            </a>
                        </AuthText>
                    );
                }

                return <div key={linkEl} />;
            })}
        </Fragment>
    );
};

AuthOptionLinks.propTypes = {
    linksToShow: PropTypes.array.isRequired
};
